module.exports = __webpack_public_path__ + "img/platform-erp_x.88236fba.png";